/**
 * interaction/facades/keyword.facade.js
 *
 * Sole business entry point for the keyword domain.
 * Bridges presentation → transport.
 *
 * Rules: R4 (no DOM / state.js reads), R5 (single domain per PR).
 *
 * Methods:
 *   preCheckKeywords(sellingPoints, selectedKeywords, jobId)
 *   marketDataKeywords(body)
 *   translateSearchTerms(body)
 *   keywordCoverageAnalyze(body)
 *   listingOptimizerDiagnose(body)
 */

export function createKeywordFacade(deps) {
  const getDeps = () => deps;

  async function facadePreCheckKeywords(sellingPoints, selectedKeywords, jobId = '', context = {}) {
    return getDeps().preCheckKeywords(sellingPoints, selectedKeywords, jobId, context);
  }

  async function facadeMarketDataKeywords(body) {
    return getDeps().marketDataKeywords(body);
  }

  async function facadeTranslateSearchTerms(body) {
    return getDeps().translateSearchTerms(body);
  }

  async function facadeKeywordCoverageAnalyze(body) {
    return getDeps().keywordCoverageAnalyze(body);
  }

  async function facadeListingOptimizerDiagnose(body) {
    return getDeps().listingOptimizerDiagnose(body);
  }

  return {
    preCheckKeywords: facadePreCheckKeywords,
    marketDataKeywords: facadeMarketDataKeywords,
    translateSearchTerms: facadeTranslateSearchTerms,
    keywordCoverageAnalyze: facadeKeywordCoverageAnalyze,
    listingOptimizerDiagnose: facadeListingOptimizerDiagnose,
  };
}
